import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-privacy-conditions',
  templateUrl: './privacy-conditions.component.html',
  styleUrls: ['./privacy-conditions.component.scss']
})
export class PrivacyConditionsComponent implements OnInit {
  
  @Output() formPrivacyUpdate = new EventEmitter<boolean>();
  formPrivacy: FormGroup;

  personalDataLink = 'https://docs.payvalida.com/documentacion-legal/autorizacion-para-el-tratamiento-de-datos-personales';
  privacityLink = 'https://docs.payvalida.com/documentacion-legal/aviso-de-privacidad';
  linksContainer = [
    {
      description: `Autorizo el <a href='${this.personalDataLink}' target='_blank' rel='noopener noreferrer'> tratamiento de datos personales</a> y
      acepto el <a href='${this.privacityLink}' target='_blank' rel='noopener noreferrer'> aviso de privacidad</a>`,
      control: 'personalData',
    },
  ];

  constructor(private formBuilder: FormBuilder) {
    this.formPrivacy = this.formBuilder.group({
      personalData: ['', Validators.requiredTrue],
    });
    this.formPrivacy.valueChanges.subscribe(() => {
      this.formPrivacyUpdate.emit(this.formPrivacy.valid);
    });
  }

  ngOnInit(): void { }

}
